import InfoModal from '@/quote/components/InfoModal';

interface HomeBrokerPowerByJoveInfomationDialogProps {
  close?: () => void;
}

const HomeBrokerPowerByJoveInfomationDialog = (props: HomeBrokerPowerByJoveInfomationDialogProps) => {
  const { close } = props;

  return (
    <InfoModal title="" isOpen={true} onClose={close}>
      <p>
        This quotation journey is powered by Jove Technology Limited, an FCA-authorised Managing General Agent, acting on behalf of the insurer. No
        advice is provided by Jove Technology Limited. Where advice is provided, it is the responsibility of the intermediary named on this website.
      </p>
    </InfoModal>
  );
};

export default HomeBrokerPowerByJoveInfomationDialog;
